import { OperatorType } from 'bones/utils/queryBuilder/constants';
import {
  DraftFilter,
  DraftTopExpression,
  Variable,
} from 'bones/utils/queryBuilder/types';

/**
 * @returns a record of all instance IDs by IRI
 */
export const getInvalidInstanceSubjects = ({
  topExpression,
  subExpressionIdx,
  expressionIdx,
  filterIdx,
}: {
  topExpression: DraftTopExpression;
  subExpressionIdx: number;
  expressionIdx: number;
  filterIdx: number;
}): Record<string, string[]> => {
  const subExpression = topExpression.expressions[subExpressionIdx];
  const expression = subExpression.expressions[expressionIdx];
  const maybeFilter: DraftFilter | undefined = expression.filters[filterIdx];
  if (maybeFilter?.operator?.operatorType !== OperatorType.INSTANCE) {
    return {};
  }

  const variables: Record<string, string[]> = {};
  if (maybeFilter.subject) {
    variables[maybeFilter.subject.iri] = [];
  }

  const addVariable = ({ id, iri }: Variable) => {
    if (!variables[iri]) {
      variables[iri] = [];
    }
    if (!variables[iri].includes(id)) {
      variables[iri].push(id);
    }
  };

  const addFilterToVariables = (filter: DraftFilter) => {
    // any other instance subjects in the sub-expression are invalid
    if (
      filter.subject &&
      filter.operator?.operatorType === OperatorType.INSTANCE
    ) {
      addVariable(filter.subject);
    }
  };

  subExpression.expressions.forEach((expression, expIdx) => {
    const filters = [...expression.filters];
    if (expressionIdx === expIdx) {
      // ignore the current filter
      filters.splice(filterIdx, 1);
    }
    filters.forEach(addFilterToVariables);
  });

  return variables;
};
